var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 134,
    viewBox: "0 0 131 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.2554 116.302C96.8128 116.302 121.594 91.7065 121.594 61.3353C121.594 30.9642 96.8128 6.36914 66.2554 6.36914C35.6979 6.36914 10.9165 30.9642 10.9165 61.3353C10.9165 91.7065 35.6979 116.302 66.2554 116.302Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.645 54.1617V87.7935C108.645 94.7808 102.962 100.464 95.8812 100.464H36.8158C29.8286 100.464 24.1457 94.8739 24.0525 87.8867C24.0525 87.7935 24.0525 87.7935 24.0525 87.7004V54.1617C24.0525 54.0685 24.0525 54.0685 24.0525 53.9753C24.0525 53.789 24.0525 53.6027 24.1457 53.4163C24.2388 53.1369 24.332 52.9505 24.4251 52.671L40.2629 22.393C40.8218 21.1819 42.033 20.5298 43.3372 20.5298H89.2666C90.5709 20.5298 91.6889 21.1819 92.341 22.393L108.179 52.671C108.272 52.8574 108.365 53.1369 108.458 53.4163C108.645 53.6027 108.645 53.8822 108.645 54.1617Z",
    fill: "#D5DDEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8765_37856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.645 54.1618V91.2407C108.645 96.3647 104.545 100.464 99.3282 100.464H33.3688C28.2448 100.464 24.0525 96.3647 24.0525 91.2407V53.9755C24.0525 53.7892 24.0525 53.6028 24.1457 53.4165H45.3868C48.5544 53.4165 51.1629 55.9319 51.1629 59.1926C51.1629 60.7764 51.8151 62.267 52.8399 63.2918C53.9578 64.4097 55.2621 64.9687 56.9391 64.9687H75.8512C79.0187 64.9687 81.6273 62.4533 81.6273 59.1926C81.6273 57.6088 82.2794 56.1182 83.3042 55.0934C84.4222 53.9755 85.7264 53.4165 87.3102 53.4165H108.458C108.645 53.6028 108.645 53.8823 108.645 54.1618Z",
    fill: "url(#paint0_linear_8765_37856)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.18 35.0634C122.29 35.0634 124 33.3533 124 31.2438C124 29.1342 122.29 27.4241 120.18 27.4241C118.071 27.4241 116.361 29.1342 116.361 31.2438C116.361 33.3533 118.071 35.0634 120.18 35.0634Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.361 22.6725C117.801 22.6725 118.969 21.5046 118.969 20.0639C118.969 18.6232 117.801 17.4553 116.361 17.4553C114.92 17.4553 113.752 18.6232 113.752 20.0639C113.752 21.5046 114.92 22.6725 116.361 22.6725Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7138 31.2437C12.1545 31.2437 13.3224 30.0758 13.3224 28.6352C13.3224 27.1945 12.1545 26.0266 10.7138 26.0266C9.27312 26.0266 8.10522 27.1945 8.10522 28.6352C8.10522 30.0758 9.27312 31.2437 10.7138 31.2437Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84448 88.6321C7.52001 88.6321 9.68896 86.4631 9.68896 83.7876C9.68896 81.1121 7.52001 78.9431 4.84448 78.9431C2.16895 78.9431 0 81.1121 0 83.7876C0 86.4631 2.16895 88.6321 4.84448 88.6321Z",
    fill: "#EAEEF9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.658 9.32153C90.8739 22.5946 91.4818 25.6343 88.7291 37.6549C87.8338 40.3273 86.9386 43.2542 85.0203 45.2904C82.3346 48.4718 77.4749 49.8717 73.5104 48.8536C69.4179 47.8355 66.0928 44.2723 65.3255 39.9455C64.6861 37.2731 65.5813 34.0916 67.8833 32.4373C70.3131 30.9102 73.7661 31.2919 75.8123 33.2008C78.1143 35.1097 79.0095 38.0366 78.8817 40.8363C78.7538 43.636 77.7307 46.4357 76.3239 48.8536C73.1438 54.7989 71.8346 54.7771 65.3255 64.5415",
    stroke: "#ABB5CC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7883 4.37812C96.3022 6.15176 94.3577 6.79672 92.4133 5.66804C90.3068 4.7006 88.8484 3.8944 89.1725 2.282C89.6586 0.669605 91.6031 0.508365 93.8716 0.347126C96.6263 0.0246462 97.1124 2.60448 96.7883 4.37812Z",
    fill: "#DAE2EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0707 5.99026C81.8809 7.44142 84.1494 8.40886 85.7698 6.9577C87.5522 5.3453 89.0106 4.21663 88.2004 2.60423C87.3902 1.15307 86.0939 1.63679 83.3392 1.95927C81.0707 2.44299 80.0985 4.37787 81.0707 5.99026Z",
    fill: "#DAE2EB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2003 0.0246929C89.3346 -0.136547 90.4688 0.508412 90.7929 1.47585C90.955 1.79833 91.117 2.28205 91.117 2.60453C91.4411 4.86189 90.6309 6.79676 89.3346 6.958C87.8762 7.28048 86.4179 5.66808 86.2559 3.57197C86.2559 2.92701 86.2559 2.60453 86.2559 2.12081C86.4179 0.992132 87.066 0.185933 88.2003 0.0246929C88.2003 0.0246929 88.3623 0.0246929 88.2003 0.0246929Z",
    fill: "#989FB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7192 78.3466C56.8997 78.3466 57.8567 77.3897 57.8567 76.2092C57.8567 75.0287 56.8997 74.0718 55.7192 74.0718C54.5388 74.0718 53.5818 75.0287 53.5818 76.2092C53.5818 77.3897 54.5388 78.3466 55.7192 78.3466Z",
    fill: "#989FB0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.978 78.3466C78.1585 78.3466 79.1154 77.3897 79.1154 76.2092C79.1154 75.0287 78.1585 74.0718 76.978 74.0718C75.7975 74.0718 74.8406 75.0287 74.8406 76.2092C74.8406 77.3897 75.7975 78.3466 76.978 78.3466Z",
    fill: "#989FB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8148 92.3845H63.1136C62.0738 92.3845 61.2073 91.518 61.2073 90.4781C61.2073 89.4383 62.0738 88.5718 63.1136 88.5718H69.757C70.7969 88.5718 71.6634 89.4383 71.6634 90.4781C71.7212 91.518 70.8546 92.3845 69.8148 92.3845Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8765_37856",
    x: 2.05249,
    y: 42.4165,
    width: 128.592,
    height: 91.0474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8765_37856"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8765_37856",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8765_37856",
    x1: 66.321,
    y1: 52.3283,
    x2: 66.321,
    y2: 100.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/Empty.29fe6d7af56a8efc88fcc20d5570e317.svg";
export { ForwardRef as ReactComponent };